/**
 * @name: fields.js
 * @description: 常用表格字段模块
 * @author: 温永江
 * @create: 2020/07/22 14:26:55
 * @update: 2020/07/22 14:26:55
 */

export default {

  description: {
    field: 'description',
    name: '备注'
  }
};
